// Content Tabs need to implement:
// const MyTabContent = ({ onValidChange }) => {                                                                                                                                                                                                                     
//  useEffect(() => { onValidChange(true); }, []);                                                                                                                                                                                                                  
//  // ...
// };
//
// const MyTabContent = ({ onValidChange }) => {
//   useEffect(() => {
//     onValidChange(formIsValid);
//   }, [formIsValid]);
//   ...
// };

import React, { useState }  from 'react';

import Button from '../Button/Button';
import styles from './Tabs.module.css';

const Tabs = (props) => {
  const [tab, setTab] = useState( props.startTab || 0 );
  const [canProceed, setCanProceed] = useState(false);

  const numItems = props.children.length;

  const changeTab = (i) => { setCanProceed(false); setTab(i); };

  const prevTabHandler = () => { changeTab(tab-1) };
  const nextTabHandler = () => { changeTab(tab+1) };

  const items = Array(props.children.length).fill(null).map( (e, i) => (
      <div key = {i}
           n={numItems}
           i={i}
           className = {`${styles.item} ${(i===tab) ? styles.selected : null}`}
           onClick = { () => changeTab(i) }
      >{props.titles[i] || ''}
      </div>
    )
  );

  const currentChild = React.cloneElement(props.children[tab], {
    onValidChange: setCanProceed
  });

  return (
  <div className = {styles.tabs} >
    <div className = {styles.header} >
      {items}
    </div>
    <div className = {styles.content} >
      {currentChild}
    </div>
    <div className = {styles.tabnav}>
      <div>
        { tab > 0 && <Button onClick={prevTabHandler}>Zurück</Button> }
      </div>
      <div>
        { tab < numItems-1 && <Button onClick={nextTabHandler} disabled={!canProceed}>Weiter</Button> }
      </div>
    </div>
  </div>
  )
}

export default Tabs;

{/* <button 
className={[styles.Button, styles[props.btnType], props.className].join(' ')}
onClick={props.clicked || props.onClick}
disabled={props.disabled} >
{props.children}
</button> */}